<template>
  <div class="systemSetting">
    <el-tabs v-model="activeName">
      <el-tab-pane label="邮件配置" name="first">
        <el-button
          type="primary"
          class="edit"
          @click="handleEdit"
          v-show="!isFirst"
          >编辑</el-button
        >
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
        >
          <el-form-item label="SMTP 主机" prop="host">
            <el-input
              v-model="ruleForm.host"
              :disabled="!isEdit && !isFirst"
              placeholder="请输入SMTP主机"
            ></el-input>
          </el-form-item>
          <el-form-item label="SMTP 端口" prop="port">
            <el-input
              v-model="ruleForm.port"
              :disabled="!isEdit && !isFirst"
              placeholder="请输入SMTP端口"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱地址" prop="email">
            <el-input
              v-model="ruleForm.email"
              :disabled="!isEdit && !isFirst"
              placeholder="请输入邮箱地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="发件人姓名" prop="senderName">
            <el-input
              v-model="ruleForm.senderName"
              :maxlength="32"
              :disabled="!isEdit && !isFirst"
              placeholder="请输入发件人姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="安全类型" prop="safeType">
            <el-radio-group
              v-model="ruleForm.safeType"
              :disabled="!isEdit && !isFirst"
            >
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">SSL</el-radio>
              <el-radio :label="2">TLS</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="身份验证" prop="auth">
            <el-switch
              v-model="ruleForm.auth"
              :disabled="!isEdit && !isFirst"
            ></el-switch>
            <span class="textTip">开启时须填写使用邮件服务的身份信息</span>
          </el-form-item>
          <el-form-item label="用户名" prop="username" v-show="ruleForm.auth">
            <el-input
              v-model="ruleForm.username"
              :disabled="!isEdit && !isFirst"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password" v-show="ruleForm.auth">
            <el-input
              type="password"
              v-model="ruleForm.password"
              :disabled="!isEdit && !isFirst"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-form
          ref="testSendForm"
          :model="testSendForm"
          label-width="110px"
          :rules="testSendRule"
        >
          <el-form-item
            label="发送测试邮件"
            class="testEmail"
            prop="testEmail"
            v-show="isEdit || isFirst"
          >
            <el-input
              v-model="testSendForm.testEmail"
              placeholder="请输入邮箱地址，系统会发送测试邮件以确认参数配置是否正确"
            ></el-input>
            <el-button
              type="primary"
              @click="testSendEmail"
              :disabled="!isEdit && !isFirst"
              >发送</el-button
            >
          </el-form-item>
          <el-form-item v-show="isFirst">
            <div class="footer">
              <el-button type="primary" @click="submitForm">保存</el-button>
            </div>
          </el-form-item>
          <el-form-item v-show="isEdit && !isFirst">
            <div class="footer">
              <el-button type="primary" @click="submitForm">确 定</el-button>
              <el-button @click="handleCancel">取 消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="审计配置" name="second">
        <el-form>
          <el-form-item label="登录/登出日志" prop="log">
            <el-switch v-model="openLog" @change="postOpenLog"></el-switch>
            <span class="textTip">开启后，系统会保留最近7天的登录日志事件</span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- <el-tab-pane label="登录配置" name="third">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>IDaaS支持双因子认证。开启双因子认证前，请确认已完成短信配置。</p>
            <p>开启双因子认证后，登录时首先使用账户密码完成第一次认证，认证通过后需再次验证短信验证码，二次认证通过后才能成功登录。</p>
            <p>如果部分应用需要自定义登录配置，请在目标应用的详情页设置。应用开启自定义登录配置后，将不受本页面功能配置影响。</p>
          </div>
        </div>
        <el-form>
          <el-form-item label="双因子认证" prop="login">
            <el-switch :disabled="disabledChange" v-model="authentication" @change="changeLogin"></el-switch>
          </el-form-item>
        </el-form>
      </el-tab-pane> -->
      <el-tab-pane label="注册配置" name="forth">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>IDaaS支持用户注册。注册时可选择是否验证用户身份，验证方式包括手机验证、邮箱验证和手机或邮箱验证。</p>
            <p>选择手机验证或邮箱验证时，请确认已完成短信配置和邮箱配置。</p>
          </div>
        </div>
        <el-form>
          <el-form-item label="用户注册" prop="register">
            <el-switch v-model="register.registrationAllowed" @change="changeRegister"></el-switch>
          </el-form-item>
          <el-form-item v-show="register.registrationAllowed" label="注册方式" prop="register">
            <el-select
              v-model="register.registerWay"
              placeholder="请选择注册方式"
              clearable
              size="small"
            >
              <el-option
                v-for="item in options"
                :key="item.name"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              class="save"
              @click="putRegister"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- <el-tab-pane label="密码策略" name="fifth">
        <div class="authTip">
          <i class="icon icon-authTip"></i>
          <div>
            <p>IDaaS支持自定义密码策略。请填写相应的正则表达式即可完成密码策略的更新。</p>
          </div>
        </div>
        <el-button
          type="primary"
          size="small"
          class="editCount"
          v-show="isEditPass === '1'"
          @click="editPass"
        >
          编辑
        </el-button>
        <el-form :rules="ruleformPassword" ref="formPassword" :model="formPassword" label-width="110px">
          <el-form-item label="密码策略" prop="regexPattern">
            <el-input
              v-model.trim="formPassword.regexPattern"
              :disabled="isEditPass === '1'"
              placeholder="请填写正则表达式"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="save"
              v-show="isEditPass !== '1'"
              @click="savePassRule"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import APIS from "@/apis/systemSetting.js"
export default {
  data() {
    return {
      openLog: false,//日志开关
      options: [
        {name: '手机验证', value: 'registerPhone'},
        {name: '邮箱验证', value: 'registerEmail'},
        {name: '手机或邮箱验证', value: 'registerPhoneEmail'}
      ],
      register: {
        registrationAllowed: false,//注册开关
        registerWay: '',
      },
      breadcrumb: [
        {
          label: "系统设置"
        }
      ],
      activeName: "first",
      testSendForm: {
        testEmail: ""
      },
      testSendRule: {
        testEmail: [
          { required: true, message: "请输入测试邮件地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入格式正确的邮件地址",
            trigger: "blur"
          }
        ]
      },
      ruleForm: {
        host: "",
        port: "",
        email: "",
        senderName: "",
        safeType: 0,
        auth: true,
        username: "",
        password: ""
      },
      rules: {
        host: [{ required: true, message: "请输入SMTP主机", trigger: "blur" }],
        port: [{ required: true, message: "请输入SMTP端口", trigger: "blur" }],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入格式正确的邮箱地址",
            trigger: "blur"
          }
        ],

        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]

        // realmName: this.$realm
      },
      isEdit: false,
      isFirst: true,
      preRuleFormData: null,
      authentication: '',//双因子认证
      disabledChange: false,
      isEditPass: '2',
      ruleformPassword: {//密码策略
        regexPattern: [{ required: true, message: "请输入密码策略", trigger: "blur" }]
      },
      formPassword: {
        regexPattern: null,
      }
    }
  },
  watch: {
    "ruleForm.auth"(newValue) {
      let authRule = {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
      Object.keys(authRule).forEach(key => {
        let rule = newValue ? authRule[key] : []
        this.rules[key] = rule
      })
      if (!newValue) {
        this.ruleForm.username = ""
        this.ruleForm.password = ""
        this.$refs.ruleForm.clearValidate(["username", "password"])
      }
    }
  },
  created() {
    this.activeName = this.$route.query.activeName || 'first'
  },
  mounted() {
    this.getEmailSetting()
    this.getAuditState()
    this.getRegister()
    // this.getPasswordPolicy()
    this.getDoubleFactor()
  },
  methods: {
    // 双因子认证开启关闭
    async changeLogin() {
      let { status } = await APIS.putDoubleFactor(this.$realm, {data: {"phoneAgain": this.authentication + ''}})
      if (status === 0) {
       this.getDoubleFactor()
      }
    },
    // 查询双因子认证状态
    async getDoubleFactor() {
      let { status, data } = await APIS.getDoubleFactor(this.$realm)
      if (status === 0) {
        this.authentication = data ? (data.phoneAgain === 'true' ? true : false) : false
        this.disabledChange = data ? false : true
      }
    },
    // 编辑密码策略
    editPass() {
      this.isEditPass = '0'
    },
    // 保存密码策略
    async savePassRule() {
      if (!this.formPassword.regexPattern) {
        return false
      }
      let { status } = await APIS.setPasswordPolicy(this.$realm, {data: this.formPassword})
      if (status === 0) {
        this.isEditPass = '1'
        this.getPasswordPolicy()
      }
    },
    // 查询密码策略
    async getPasswordPolicy() {
      let { status, data } = await APIS.getPasswordPolicy(this.$realm)
      if (status === 0) {
        this.isEditPass = (data.regexPattern === null ||  data === null) ? '0' : '1'
        this.formPassword.regexPattern = data ? data.regexPattern : ''
      }
    },
    // 查询审计状态
    async getAuditState() {
      let { status, data } = await APIS.getAuditState(this.$realm)
      if (status === 0) {
        this.openLog = data
      }
    },
    // 打开日志
    async postOpenLog() {
      let { status } = await APIS.auditConfig(this.$realm, { data: { eventsEnabled:this.openLog } })
      if (status === 0) {
        this.getAuditState()
      } else {
        this.openLog = !this.openLog
      }
    },
    // changeRegister(e) {
    //   !e ? this.putRegister() : ''
    // },
    changeRegister(e) {
      if (e) {
        // 当开关打开时，如果注册方式未设置，设置默认值
        if (!this.register.registerWay) {
          this.register.registerWay = 'registerPhone'
        }
      } else {
        this.putRegister()
      }
    },
    async getRegister() {
      let { status, data } = await APIS.getRegister(this.$realm, { data: this.register })
      if (status === 0) {
        this.register.registrationAllowed = data.registrationAllowed
        this.register.registerWay = data.registerWay
        if (this.register.registrationAllowed && (!this.register.registerWay || this.register.registerWay === '')) {
          this.register.registerWay = 'registerPhone'
        }
      }
    },
    async putRegister() {
      let { status } = await APIS.registerConfig(this.$realm, { data: this.register })
      if (status === 0) {
        this.getRegister()
      }
    },
    // 获取邮件配置
    async getEmailSetting() {
      let { status, data } = await APIS.getEmailSetting(this.$realm)
      if (status === 0 && data.host) {
        this.isFirst = false
        this.ruleForm.host = data.host
        this.ruleForm.port = data.port
        this.ruleForm.email = data.from
        this.ruleForm.senderName = data.fromName
        this.ruleForm.safeType = data.securityType
        this.ruleForm.auth = data.auth
        this.ruleForm.username = data.auth ? data.user : ""
        this.ruleForm.password = data.auth ? "12345678" : "" // 假的
        // 存储数据
        this.preRuleFormData = JSON.stringify(this.ruleForm)
      } else {
        this.isFirst = true
      }
    },
    // 设置邮件配置
    async putEmailSetting() {
      let params = {
        host: this.ruleForm.host,
        port: this.ruleForm.port,
        from: this.ruleForm.email,
        fromName: this.ruleForm.senderName,
        securityType: this.ruleForm.safeType,
        auth: this.ruleForm.auth,
        user: this.ruleForm.username,
        password: this.ruleForm.password
      }
      let { status } = await APIS.putEmailSetting(this.$realm, {
        data: params
      })
      if (status === 0) {
        this.isEdit = false
        this.isFirst = false
        this.getEmailSetting()
        this.$message.success({
          message: "邮件配置成功"
        })
      }
    },
    // 测试发送邮件
    async postSendEmail() {
      let params = {
        host: this.ruleForm.host,
        port: this.ruleForm.port,
        from: this.ruleForm.email,
        fromName: this.ruleForm.senderName,
        securityType: this.ruleForm.safeType,
        auth: this.ruleForm.auth,
        user: this.ruleForm.username,
        password: this.ruleForm.password,
        to: this.testSendForm.testEmail
      }
      let { status } = await APIS.postSendEmail(this.$realm, {
        data: params
      })
      if (status === 0) {
        this.$message.success({
          message: "邮件发送成功"
        })
      }
    },
    // 发送测试邮件
    testSendEmail() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$refs.testSendForm.validate((valid) => {
            if (valid) {
              this.postSendEmail()
            }
          })
        }
      })
    },
    // 编辑
    handleEdit() {
      this.isEdit = true
      this.ruleForm.password = ""
    },
    // 提交表单
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (JSON.stringify(this.ruleForm) === this.preRuleFormData) {
            this.isEdit = false
            this.isFirst = false
            return
          }
          this.putEmailSetting()
        }
      })
    },
    handleCancel() {
      this.isEdit = false
      this.$refs["ruleForm"].resetFields()
      this.$refs["testSendForm"].resetFields()
      this.ruleForm = JSON.parse(this.preRuleFormData)
    }
  }
}
</script>

<style lang="scss">
.systemSetting {
  .el-button.edit {
    margin-bottom: 15px;
  }
  .el-form {
    width: 610px;
    .el-form-item.testEmail {
      .el-form-item__label::before {
        content: none;
      }
      .el-input {
        width: 420px;
      }
      .el-button {
        position: absolute;
        top: 5px;
        right: 0px;
      }
    }
  }
  .el-form-item__content {
    .textTip {
      color: #999;
      font-size: 13px;
      margin-left: 20px;
      vertical-align: middle;
    }
  }
  .save{
    margin-left: 10px;
  }
}
</style>
